/* @jsx h */
import { defineComponent, h, Ref } from "vue";
import { CartItem } from "@lemmonhq/types";
import { LemmonModal } from "@app/vue/components/index";
import { useLocalization } from "@lemmonhq/uikit";
import { pp, sanitizeOrderNote } from "@app/utils/clientBusiness";

interface NotesModalProps {
  items: CartItem[];
  isOpen: boolean;
  onClose: () => void;
  notes: Ref<{ [key: string]: string }>;
  onSave: (notes: { [key: string]: string }) => void;
}

export const NotesModal = defineComponent<NotesModalProps>({
  name: "NotesModal",
  props: ["items", "isOpen", "onClose", "onSave", "notes"],
  setup(props) {
    const notes = props.notes;
    const { t } = useLocalization();

    const handleSubmit = (e: Event) => {
      e.preventDefault();
      console.log("notes", notes);
      props.onSave(notes.value);
      props.onClose();
    };

    const getItemKey = (item: CartItem) => {
      return item.guid;
    };

    return () =>
      !props.isOpen ? null : (
        <div>
          <LemmonModal
            title={t("pos.pay.add_notes")}
            onClose={props.onClose}
            height="calc(100dvh - 0px)"
            renderButtons={() => (
              <div class="border-t  bg-base-100 p-4">
                <div class="flex flex-col justify-between gap-2 sm:flex-row">
                  <button
                    onClick={() => props.onClose()}
                    class="btn btn-neutral min-h-12 flex-1"
                    type="button"
                  >
                    {t("general.words.cancel")}
                  </button>
                  <button
                    onClick={handleSubmit}
                    class="btn btn-primary min-h-12 flex-1"
                    type="submit"
                  >
                    {t("pos.pay.add_notes")}
                  </button>
                </div>
              </div>
            )}
          >
            <div class="flex-1 space-y-4 px-4 py-4 sm:px-8 sm:py-6">
              {props.items.map((item) => (
                <div
                  key={getItemKey(item)}
                  class="space-y-2 rounded-2xl border  bg-base-200/40 p-3 sm:p-4"
                >
                  <label class="form-control w-full gap-2">
                    <div class="label px-0 py-0">
                      <span class="label-text flex items-center gap-2 text-accent font-semibold">
                        <span class="inline-flex min-h-9 min-w-9 items-center justify-center rounded-full bg-base-100 px-3 text-sm text-accent">
                          {item.quantity}
                        </span>
                        {item.name}
                      </span>
                    </div>
                    <textarea
                      value={notes.value[getItemKey(item)] || item.note || ""}
                      onInput={(e) => {
                        const rawValue = (e.target as HTMLTextAreaElement)
                          .value;
                        const sanitizedValue = sanitizeOrderNote(rawValue);
                        console.log(
                          pp({
                            rawValue,
                            sanitizedValue,
                          }),
                        );
                        notes.value = {
                          ...notes.value,
                          [getItemKey(item)]: sanitizedValue,
                        };
                      }}
                      class="textarea textarea-bordered min-h-24 w-full resize-none rounded-xl px-4 py-3 text-base leading-6"
                      rows={3}
                      placeholder={t("pos.pay.add_notes_placeholder")}
                    />
                  </label>
                </div>
              ))}
            </div>
          </LemmonModal>
        </div>
      );
  },
});
